import { render } from "./RoleFormPage.vue?vue&type=template&id=4eb98226&ts=true"
import script from "./RoleFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoleFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/role/RoleFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4eb98226"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eb98226', __exports__)) {
    api.reload('4eb98226', __exports__)
  }
  
  module.hot.accept("./RoleFormPage.vue?vue&type=template&id=4eb98226&ts=true", () => {
    api.rerender('4eb98226', render)
  })

}


export default __exports__